window.initHubBlog ?? (() => {
    window.initHubBlog = (section_id) => {
        const replaceTitleTMs = () => {
            document.querySelectorAll(`section#shopify-section-${section_id} h1`).forEach((title) => {
                title.innerHTML = title.innerHTML.replace(
                    /™/g,
                    '<span class="tm">™</span>'
                    );
            });
        }

        replaceTitleTMs();

        const filterCategory = () => {
            const filterMobile = document.querySelector(`section#shopify-section-${section_id} .hub-blog-header-select`);
            const trigger = filterMobile.querySelector('.hub-blog-header-select-trigger');
            const links = filterMobile.querySelectorAll('.hub-blog-header-select-dropdown a');
            const triggerText = trigger.querySelector('span');

            const filterDesktop = document.querySelectorAll(`section#shopify-section-${section_id} .hub-blog-header-tags .button`);

            trigger.addEventListener('click', () => {
                const isOpen = filterMobile.classList.toggle('is-open');
                trigger.setAttribute('aria-expanded', isOpen);
            });

            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    console.log(e);
                    if(e.currentTarget.getAttribute('href').indexOf('#') == 0) {
                        e.preventDefault();
                        links.forEach(link => link.classList.remove('active'));
                        link.classList.add('active');

                        triggerText.textContent = link.textContent.trim();

                        filterMobile.classList.remove('is-open');
                        trigger.setAttribute('aria-expanded', 'false');
                        
                        document.querySelector(e.currentTarget.getAttribute('href')).scrollIntoView({
                            behavior: 'smooth'
                        });
                    } 
                });
            });

            document.addEventListener('click', event => {
                if (!filterMobile.contains(event.target)) {
                    filterMobile.classList.remove('is-open');
                    trigger.setAttribute('aria-expanded', 'false');
                }
            });

            filterDesktop.forEach(tag => {
                tag.addEventListener('click', (e) => {
                    console.log(e);
                    if(e.currentTarget.getAttribute('href').indexOf('#') == 0) {
                        e.preventDefault();
                        filterDesktop.forEach(tag => tag.classList.remove('active'));
                        tag.classList.add('active');
                        document.querySelector(e.currentTarget.getAttribute('href')).scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }

        filterCategory();

    }
})();